var _linearGradient, _linearGradient2, _linearGradient3, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVsCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 23.79,
    x2: 23.79,
    y1: 2,
    y2: 30
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32b5f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b9fed"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 21.0018,
    x2: 1.0217,
    y1: 5.53398,
    y2: 22.3051
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f6fb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270551,
    stopColor: "#1279b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421376,
    stopColor: "#1176b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.618197,
    stopColor: "#0e69ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855344,
    stopColor: "#0f70af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f6dad"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 1.15522,
    x2: 21.0791,
    y1: 9.98389,
    y2: 26.4808
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1791d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1173c5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.0016 3.11679c0-.87896-.9841-.87897-1.4215-.7691.6123-.48343 1.3304-.36622 1.5855-.21973l5.9134 2.89951c.5634.27628.9208.85113.9208 1.4811v19.07453c0 .6384-.3669 1.2194-.9418 1.4912l-5.5643 2.6311c-.3828.1647-1.2138.5713-1.9136-.0001.8748.1649 1.3486-.4577 1.4215-.8789z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.6512 2.3319c.4642-.09173 1.3506-.04919 1.3506.78495v6.56569l-17.92821 13.56276c-.31337.2371-.75439.1977-1.0213-.0911l-1.847758-1.9994c-.2894678-.3132-.2692144-.8035.045092-1.0915l19.330576-17.71555z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m21.0018 22.3708-17.92821-13.56279c-.31337-.23707-.75439-.19773-1.0213.09109l-1.847758 1.9994c-.2894678.3132-.2692144.8035.045092 1.0916l19.330576 17.7155c.8748.1648 1.3487-.4578 1.4216-.879z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVsCode);
export default __webpack_public_path__ + "static/media/vs-code.b85c734d75b2d0dddfc87f0a1f07f8ae.svg";
export { ForwardRef as ReactComponent };